var map = {
	"./decidim/avatar-multiuser.png": 14452,
	"./decidim/brands/facebook.svg": 71290,
	"./decidim/brands/google.svg": 54043,
	"./decidim/brands/twitter-x.svg": 47496,
	"./decidim/cc-badge.png": 47286,
	"./decidim/decidim-logo.svg": 85174,
	"./decidim/default-avatar.svg": 13842,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 84854,
	"./decidim/icons.svg": 77509,
	"./decidim/pattern.png": 73074,
	"./decidim/placeholder-card-g.svg": 99231,
	"./decidim/placeholder-card-l.svg": 79492,
	"./decidim/placeholder.jpg": 33019,
	"./decidim/remixicon.symbol.svg": 41075,
	"./decidim/vendor/social-share-button/douban.svg": 84898,
	"./decidim/vendor/social-share-button/email.svg": 50239,
	"./decidim/vendor/social-share-button/facebook.svg": 37793,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 75539,
	"./decidim/vendor/social-share-button/hacker_news.svg": 96467,
	"./decidim/vendor/social-share-button/linkedin.svg": 22671,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 360,
	"./decidim/vendor/social-share-button/pinterest.svg": 8241,
	"./decidim/vendor/social-share-button/reddit.svg": 21985,
	"./decidim/vendor/social-share-button/telegram.svg": 85656,
	"./decidim/vendor/social-share-button/tumblr.svg": 20079,
	"./decidim/vendor/social-share-button/twitter.svg": 8174,
	"./decidim/vendor/social-share-button/vkontakte.svg": 73456,
	"./decidim/vendor/social-share-button/wechat.svg": 4923,
	"./decidim/vendor/social-share-button/whatsapp.svg": 7891,
	"./decidim/vendor/social-share-button/x.svg": 11447,
	"./decidim/vendor/social-share-button/xing.svg": 737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94947;